import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        // if (value.length > 40) {
        //   callback(new Error('账号长度不能超过40位'));
        // }
        // if (!/^\S+$/.test(value)) {
        //   callback(new Error('账号格式不正确'));
        // }
        // if (!/^(?!.*\s)([a-zA-Z0-9_-]{6,40}|[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9.-]{1,30}\.[a-zA-Z]{2,})$/.test(value)) {
        //   callback(new Error('账号格式不正确'));
        // }
        // if (!/^[a-zA-Z0-9\._%+-]{1,20}@[a-zA-Z0-9\.-]{1,15}\.[a-zA-Z]{1,5}$/.test(value) && process.env.VUE_APP_LOCATION == "VN" ) {
        //   callback(new Error('账号格式不正确'));
        // }
        // if (!/^[a-zA-Z0-9]{6,30}$/.test(value) && process.env.VUE_APP_LOCATION == "CN") {
        //   callback(new Error('请输入6-30位账号'));
        // }
        if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,30}$/.test(value)) {
          callback(new Error('账号必须由字母和数字组成，长度6-30位'));
        }

        callback();
      }
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        account: "",
        password: "",
        password_confirm: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择应用",
          trigger: "blur"
        }],
        // account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        password_confirm: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        account: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }]
      },
      user_id: '',
      dialogVisible: false
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                _context.next = 3;
                return _this.getcommonData(['appListAllData']);

              case 3:
                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetVaildate: function resetVaildate() {
      this.$refs.ruleForm.validateField('account');
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.dialogFormVisible = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 10;
                    break;
                  }

                  if (!_this2.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this2.secondConfirmation();

                case 4:
                  data = JSON.parse(JSON.stringify(_this2.formData));
                  data.account = JSON.stringify(data.account);
                  reqFn = _this2.formData.id ? 'appLoginSdkConfigUpdate' : 'registerUser';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.user_id = res.data; // this.$message({ message: '操作成功', type: 'success' });

                      _this2.$emit('change');

                      _this2.dialogVisible = true;
                    }
                  });

                  _context2.next = 11;
                  break;

                case 10:
                  return _context2.abrupt("return", false);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};